import './select-specimens-error-dialog.scss'

import { defineComponent, PropType } from 'vue';
import { BModal } from 'bootstrap-vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { SpecimenResource } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { CANCEL_ALL_SELECT_SPECIMEN, CANCEL_ONE_SELECT_SPECIMEN, RETRY_ALL_SELECT_SPECIMEN, RETRY_ONE_SELECT_SPECIMEN } from '../../events';
import { BasicSpecimenCard } from '../../cards/specimen/basic-specimen-card';

export interface SpecimenSelectionFailure {
    specimen: SpecimenResource,
    info?: string,
    currentlyUploading?: boolean,
}

export const SelectSpecimensErrorDialog = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBasicSpecimenCard: BasicSpecimenCard,
    },
    props: {
        specimensWhoFailed: {
            type: Array as PropType<SpecimenSelectionFailure[]>,
            required: true,
        },
        title: {
            type: String,
            default: "selectItemErrorDialog.title",
        },
        description: {
            type: String,
            default: "selectItemErrorDialog.description",
        },
    },
    template: require('./select-specimens-error-dialog.html'),
    data() {
        return {
            loadingIcon: faCircleNotch,
        }
    },
    computed: {
        someSpecimenCurrentlyUploading(): boolean {
            return this.specimensWhoFailed.findIndex(failedSpecimen => {
                return failedSpecimen.currentlyUploading
            }) > -1
        },
        computedDescription(): string {
            return (this.$t(this.description as string, [this.specimensWhoFailed.length]) ?? this.description) as string
        },
    },
    methods: {
        onRetryAll() {
            this.$emit(RETRY_ALL_SELECT_SPECIMEN)
        },
        onCancelAll() {
            this.$emit(CANCEL_ALL_SELECT_SPECIMEN)
        },
        onRetry(index: number) {
            this.$emit(RETRY_ONE_SELECT_SPECIMEN, index)
        },
        onCancel(index: number) {
            this.$emit(CANCEL_ONE_SELECT_SPECIMEN, index)
        },
        onHide(event) {
            this.$emit('hidden', event)
        },
        isUploading(index: number): boolean {
            return this.specimensWhoFailed?.[index]?.currentlyUploading ?? false
        },
        closeModal() {
            (this.$refs.modal as BModal).hide()
        },
        openModal() {
            (this.$refs.modal as BModal).show()
        },
    },
})
